import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { TooltipV2 } from 'builder/components/Tooltip'
import Shadows from 'builder/styles/shadows'
import Icon from 'builder/components/Icon'

export const Container = styled.div`
  cursor: pointer;
`

export const Tooltip = styled(TooltipV2)`
  box-shadow: ${Shadows.dark.mid};
  color: ${Colors.Neutral90};
  background-color: ${Colors.White};

  .tippy-arrow {
    color: ${Colors.White};
  }

  .tippy-box[data-placement^='top'] .tippy-arrow::before {
    border-top-color: ${Colors.White};
  }

  .tippy-box[data-placement^='bottom'] .tippy-arrow::before {
    border-bottom-color: ${Colors.White};
  }

  .tippy-box[data-placement^='left'] .tippy-arrow::before {
    border-left-color: ${Colors.White};
  }

  .tippy-box[data-placement^='right'] .tippy-arrow::before {
    border-right-color: ${Colors.White};
  }
`

export const TooltipIconWrapper = styled.div`
  width: 24px;
  height: 24px;
`

export const TooltipIcon = styled(Icon.Info)`
  color: ${Colors.Green50};
`

export const TooltipValue = styled.div`
  display: flex;
  gap: ${Spacing['3XS']};
`
